import { render, staticRenderFns } from "./CategoryItem.vue?vue&type=template&id=a2ddd780"
import script from "./CategoryItem.vue?vue&type=script&lang=js"
export * from "./CategoryItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/stefanschmidt/Entwicklung/plentyDev2025/7843/112/Servershop5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a2ddd780')) {
      api.createRecord('a2ddd780', component.options)
    } else {
      api.reload('a2ddd780', component.options)
    }
    module.hot.accept("./CategoryItem.vue?vue&type=template&id=a2ddd780", function () {
      api.rerender('a2ddd780', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/servershop/CategoryItem.vue"
export default component.exports